import React from 'react';
import type { RouteContext } from '@atlassian/react-resource-router';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';

type AllProps = RouteContext;

export const LegacyEditPermissionsPage = (props: AllProps): React.JSX.Element => (
	<>
		<LegacyPage {...props} />
	</>
);

export default LegacyEditPermissionsPage;
